/* Profit On Your Terms's Start here (src/products/poyt/start-here): live's pre-course screens in POYT's
   look (navy, orange, paper, ink; Archivo headings, IBM Plex Sans body), inside the product's frame.
   No board draws them: the laptop layout is live's (the list of screens beside the screen), cards and
   buttons follow POYT.dc.html, and a phone follows PhoneWeek.dc.html. Every colour is a token from
   tokens.css: live's green (a keeper, a let rent, the sweet spot) and its cream script blocks become
   navy and paper here, because POYT's look never uses green or cream. */

.ps {
  display: grid; grid-template-columns: 300px minmax(0, 840px); gap: 40px; align-items: start;
  color: var(--poyt-ink); font-family: var(--poyt-body-font);
}
.ps[aria-busy='true'] { min-height: 60vh; }
.ps-main { min-width: 0; }

/* ---- The list of screens */
.ps-rail {
  background: var(--shell-bg); border: 1px solid var(--poyt-rule); border-radius: 16px; padding: 22px 14px 18px;
}
.ps-rail-head { padding: 0 8px 14px; border-bottom: 1px solid var(--poyt-rule-soft); display: flex; flex-direction: column; gap: 6px; }
.ps-rail-title { margin: 0; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 20px; letter-spacing: -0.01em; }
.ps-rail-count { margin: 0; font-size: 14px; font-weight: 600; color: var(--poyt-orange); }
.ps-rail-bar { display: block; height: 5px; border-radius: 3px; background: var(--poyt-rule); overflow: hidden; margin-top: 4px; }
.ps-rail-bar span { display: block; height: 100%; border-radius: 3px; background: var(--poyt-orange-2); }
.ps-rail-toggle {
  display: none; align-items: center; min-height: 40px; padding: 0 14px; border: 1px solid var(--poyt-done-line); border-radius: 10px;
  background: var(--shell-bg); color: var(--poyt-navy); font: inherit; font-size: 14px; font-weight: 600; cursor: pointer; white-space: nowrap;
}
.ps-rail-group { padding-top: 14px; }
.ps-rail-group-h {
  margin: 0 8px 6px; font-size: 11px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: var(--poyt-soft);
}
.ps-rail ol { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 2px; }
.ps-rail-item {
  display: flex; align-items: flex-start; gap: 10px; padding: 8px; border-radius: 8px; font-size: 14px; line-height: 1.35;
  text-decoration: none; position: relative;
}
.ps .ps-rail-item { color: var(--poyt-ink); }
.ps .ps-rail-item:hover { background: var(--poyt-navy-07); }
.ps .ps-rail-item--here { background: var(--poyt-navy-07); font-weight: 600; box-shadow: inset 3px 0 0 var(--poyt-orange); }
.ps .ps-rail-item--locked { color: var(--poyt-soft); cursor: default; }
.ps .ps-rail-item--locked:hover { background: none; }
.ps-rail-text { min-width: 0; }
.ps-rail-dot {
  width: 18px; height: 18px; border-radius: 9px; flex-shrink: 0; margin-top: 1px; display: flex; align-items: center; justify-content: center;
  border: 1.5px solid var(--poyt-line); color: var(--on-dark);
}
.ps-rail-dot--done { background: var(--poyt-orange); border-color: var(--poyt-orange); }
.ps-rail-dot--here:not(.ps-rail-dot--done) { border-color: var(--poyt-orange); box-shadow: inset 0 0 0 3px var(--shell-bg), inset 0 0 0 9px var(--poyt-orange); }
.ps-rail-dot--locked { border: none; color: var(--poyt-soft); }
.ps-rail-dot .icon-line { stroke: currentColor; fill: none; stroke-linecap: round; stroke-linejoin: round; }

/* ---- A screen */
.ps-card {
  background: var(--shell-bg); border: 1px solid var(--poyt-rule); border-radius: 16px; padding: 40px 44px 36px;
  font-size: 16.5px; line-height: 1.65;
}
.ps-eyebrow { font-size: 13px; font-weight: 600; letter-spacing: 0.16em; text-transform: uppercase; color: var(--poyt-orange); }
.ps-eyebrow--small { font-size: 12px; letter-spacing: 0.13em; margin-bottom: 8px; }
.ps-h1 {
  margin: 10px 0 22px; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 36px; line-height: 1.12;
  letter-spacing: -0.01em; color: var(--poyt-ink);
}
.ps-takeaway {
  display: flex; gap: 14px; align-items: flex-start; margin: 2px 0 24px; padding: 13px 18px; border-radius: 10px;
  background: var(--poyt-navy-07); color: var(--poyt-navy);
}
.ps-takeaway b {
  flex: none; width: 62px; padding-top: 4px; font-family: var(--poyt-heading-font); font-weight: 700; font-size: 11px;
  line-height: 1.3; letter-spacing: 0.12em; text-transform: uppercase; color: var(--poyt-soft);
}
.ps-takeaway p { margin: 0; font-size: 15px; line-height: 1.55; }

/* the words */
.ps-md p { margin: 0 0 16px; }
.ps-md p:last-child { margin-bottom: 0; }
.ps-md h2 { margin: 28px 0 10px; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 21px; line-height: 1.25; letter-spacing: -0.01em; }
.ps-md h3 { margin: 22px 0 8px; font-family: var(--poyt-heading-font); font-weight: 700; font-size: 18px; }
.ps-md ol, .ps-md ul { margin: 0 0 16px; padding-left: 24px; }
.ps-md li { margin-bottom: 8px; padding-left: 2px; }
.ps-md strong { font-weight: 600; }
.ps-md blockquote { margin: 0 0 16px; padding: 6px 0 6px 16px; border-left: 3px solid var(--poyt-orange); color: var(--poyt-soft); }
.ps-hl { color: var(--poyt-orange); font-weight: 600; }
.ps-script {
  margin: 22px 0; padding: 16px 22px; border: 1px solid var(--poyt-rule); border-left: 4px solid var(--poyt-orange);
  border-radius: 0 10px 10px 0; background: var(--poyt-paper);
}
.ps-script-label {
  margin-bottom: 9px; font-family: var(--poyt-heading-font); font-weight: 700; font-size: 11px; letter-spacing: 0.13em;
  text-transform: uppercase; color: var(--poyt-orange);
}
.ps-script p { margin: 0 0 10px; font-family: var(--poyt-heading-font); font-weight: 600; font-size: 17px; line-height: 1.55; color: var(--poyt-navy); }
.ps-script p:last-child { margin-bottom: 0; }

/* the formula */
.ps-formula { margin: 20px 0; padding: 22px 26px; border-radius: 12px; background: var(--poyt-navy); color: var(--on-dark); }
.ps-formula-line { margin: 0; font-family: var(--poyt-heading-font); font-weight: 700; font-size: 19px; line-height: 1.5; }
.ps-formula-hl { color: var(--poyt-orange-2); }
.ps-formula-note { margin: 8px 0 0; font-size: 14px; line-height: 1.55; color: var(--poyt-soft-on-navy); }

/* buttons, in POYT.dc.html's: navy to go on, a line to go back */
.ps-btn {
  min-height: 46px; padding: 0 20px; border-radius: 10px; border: 1px solid var(--poyt-navy); background: var(--poyt-navy);
  font-weight: 600; font-size: 15px; display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  text-decoration: none; white-space: nowrap; cursor: pointer;
}
.ps .ps-btn { color: var(--on-dark); }
.ps-btn:disabled, .ps-btn[aria-disabled='true'] { background: var(--poyt-line); border-color: var(--poyt-line); cursor: default; }
.ps .ps-btn:disabled { color: var(--poyt-ink); }
.ps-btn--quiet { background: var(--shell-bg); border-color: var(--poyt-done-line); }
.ps .ps-btn--quiet { color: var(--poyt-navy); }
.ps-btn--quiet:hover { border-color: var(--poyt-navy); }

/* the foot of a screen */
.ps-foot { display: flex; justify-content: space-between; align-items: center; gap: 14px; margin-top: 30px; padding-top: 22px; border-top: 1px solid var(--poyt-rule-soft); flex-wrap: wrap; }
.ps-foot-right { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; justify-content: flex-end; margin-left: auto; }
.ps-gate-help { max-width: 280px; font-size: 14px; line-height: 1.45; color: var(--poyt-soft); text-align: right; }
.ps-done-tag { display: inline-flex; align-items: center; gap: 6px; font-size: 14px; font-weight: 600; color: var(--poyt-orange); }
.ps-done-tag .icon-line { stroke: currentColor; fill: none; stroke-linecap: round; stroke-linejoin: round; }
.ps-line { margin: 14px 0 0; padding: 11px 14px; border-radius: 8px; border: 1px solid var(--poyt-orange); background: var(--shell-bg); font-size: 15px; color: var(--poyt-ink); }

/* a screen not open yet */
.ps-locked-line { margin: 0 0 20px; font-size: 17px; color: var(--poyt-soft); }

/* ---- The widgets */
.ps-ex { margin-top: 26px; }
.ps-ex-card { margin-bottom: 14px; padding: 18px 20px; border: 1px solid var(--poyt-rule); border-radius: 12px; background: var(--shell-bg); }
.ps-q { margin: 0 0 12px; font-weight: 600; }
.ps-q--plain { font-weight: 400; }
.ps-opts { display: flex; flex-wrap: wrap; gap: 10px; }
.ps-opts--stack { flex-direction: column; align-items: stretch; }
.ps-opt {
  min-height: 44px; padding: 10px 16px; border: 1.5px solid var(--poyt-rule); border-radius: 10px; background: var(--shell-bg);
  font: inherit; font-size: 15px; line-height: 1.45; text-align: left; cursor: pointer;
}
.ps .ps-opt { color: var(--poyt-ink); }
.ps-opt:hover:not(:disabled):not(.ps-opt--chosen) { border-color: var(--poyt-soft); }
.ps-opt:disabled { cursor: default; }
.ps-opt--right { border-color: var(--poyt-orange); background: var(--poyt-navy-07); font-weight: 600; }
.ps .ps-opt--wrong { border-color: var(--poyt-line); background: var(--poyt-paper); color: var(--poyt-soft); }
.ps-opt--reveal { border-color: var(--poyt-orange); }
.ps-opt--chosen { border-color: var(--poyt-orange); background: var(--poyt-navy-07); font-weight: 600; }
.ps-opt-hint { display: block; margin-top: 2px; font-weight: 400; font-size: 13.5px; color: var(--poyt-soft); }
.ps-fb { margin: 12px 0 0; padding: 12px 16px; border-radius: 10px; font-size: 15px; line-height: 1.6; }
.ps-fb--right { background: var(--poyt-navy-07); box-shadow: inset 4px 0 0 var(--poyt-orange); }
.ps-fb--wrong { background: var(--poyt-paper); border: 1px solid var(--poyt-rule); }
.ps-fb-tag { margin-right: 6px; font-family: var(--poyt-heading-font); font-weight: 700; }
.ps-fb--right .ps-fb-tag { color: var(--poyt-orange); }
.ps-fb--wrong .ps-fb-tag { color: var(--poyt-soft); }
.ps-tally { margin: 4px 0 14px; font-size: 14px; color: var(--poyt-soft); }
.ps-done-md { margin-top: 18px; }
.ps-small { font-size: 14px; line-height: 1.55; color: var(--poyt-soft); margin: 12px 0 0; }

/* a worked example */
.ps-run {
  margin: 0 0 20px; padding: 16px 18px; border-radius: 12px; background: var(--poyt-navy);
  display: grid; grid-template-columns: repeat(auto-fit, minmax(118px, 1fr)); gap: 16px;
}
.ps-run-f { margin: 0; min-width: 0; }
.ps-run dt { font-family: var(--poyt-heading-font); font-weight: 700; font-size: 11px; line-height: 1.3; letter-spacing: 0.11em; text-transform: uppercase; color: var(--poyt-soft-on-navy); }
.ps-run dd { margin: 4px 0 0; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 19px; letter-spacing: -0.01em; color: var(--on-dark); font-variant-numeric: tabular-nums; }
.ps-run-none { display: inline-block; width: 28px; height: 4px; margin: 10px 0 5px; border-radius: 2px; background: var(--on-dark-20); }
.ps-walk { list-style: none; margin: 0; padding: 0 0 0 8px; }
.ps-walk-step { position: relative; padding: 2px 0 18px 20px; border-left: 3px solid var(--poyt-rule); }
.ps-walk-step::before {
  content: ''; position: absolute; left: -8px; top: 4px; width: 13px; height: 13px; border-radius: 50%;
  background: var(--poyt-orange); border: 3px solid var(--shell-bg);
}
.ps-walk-step:last-child { padding-bottom: 4px; }
.ps-walk-h { margin: 0 0 6px; font-family: var(--poyt-heading-font); font-weight: 700; font-size: 17px; }
.ps-walk-next { margin: 10px 0 0 28px; }

/* the calculator and the letter budget */
.ps-calc { margin-top: 18px; padding: 22px 24px; border: 1px solid var(--poyt-rule); border-radius: 12px; background: var(--poyt-paper); }
.ps-calc-row { display: flex; align-items: center; justify-content: space-between; gap: 14px; margin-bottom: 14px; flex-wrap: wrap; }
.ps-calc-label { font-weight: 600; font-size: 15px; line-height: 1.45; flex: 1 1 260px; min-width: 0; }
.ps-calc-sub { display: block; font-weight: 400; font-size: 13.5px; color: var(--poyt-soft); }
.ps-calc input, .ps-calc select {
  width: 160px; max-width: 100%; height: 44px; padding: 0 12px; border: 1px solid var(--poyt-line); border-radius: 8px;
  background: var(--shell-bg); color: var(--poyt-ink); font: inherit; font-size: 16px;
}
.ps-calc input { text-align: right; }
.ps-calc select { width: 260px; }
.ps-toggle { display: flex; gap: 8px; flex-wrap: wrap; }
.ps-toggle button {
  min-height: 40px; padding: 8px 14px; border: 1.5px solid var(--poyt-rule); border-radius: 8px; background: var(--shell-bg);
  font: inherit; font-size: 14px; color: var(--poyt-ink); cursor: pointer;
}
.ps-toggle .ps-toggle-on { border-color: var(--poyt-orange); background: var(--poyt-navy-07); font-weight: 600; }
.ps-calc-out { margin-top: 6px; padding: 18px 22px; border-radius: 10px; background: var(--poyt-navy); color: var(--on-dark); }
.ps-calc-out-label { font-size: 12px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: var(--poyt-soft-on-navy); }
.ps-calc-out-num { font-family: var(--poyt-heading-font); font-weight: 800; font-size: 32px; line-height: 1.2; color: var(--poyt-orange-2); }
.ps-calc-out-working { margin: 6px 0 0; font-size: 13.5px; line-height: 1.5; color: var(--poyt-soft-on-navy); }
.ps-totals { margin-top: 8px; }
.ps-totline { display: flex; justify-content: space-between; gap: 12px; padding: 7px 0; border-bottom: 1px solid var(--poyt-rule); font-size: 15px; }
.ps-totline--total { border-bottom: none; font-weight: 700; font-size: 16px; }
.ps-totline--total b { color: var(--poyt-orange); }
.ps-band { margin-top: 16px; }
.ps-band-track { position: relative; height: 12px; border-radius: 6px; background: var(--poyt-rule); }
.ps-band-zone { position: absolute; top: 0; left: 33.333%; width: 33.333%; height: 12px; border-radius: 6px; background: var(--poyt-orange-2); opacity: 0.3; }
.ps-band-fill { position: absolute; top: 2px; left: 0; height: 8px; max-width: 100%; border-radius: 4px; background: var(--poyt-navy); transition: width 0.25s; }
.ps-band-labels { display: flex; justify-content: space-between; margin-top: 6px; font-size: 12px; color: var(--poyt-soft); }
.ps-save-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-top: 16px; }
.ps-save-row .ps-small { margin: 0; }

/* the drill */
.ps-drill-in { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; margin-top: 10px; }
.ps-drill-in input {
  width: 180px; height: 46px; padding: 0 12px; border: 1px solid var(--poyt-line); border-radius: 8px; background: var(--shell-bg);
  color: var(--poyt-ink); font: inherit; font-size: 16px;
}

/* the 7 channels */
.ps-chans { margin-top: 18px; }
.ps-chan { margin-bottom: 12px; border: 1px solid var(--poyt-rule); border-radius: 12px; background: var(--shell-bg); overflow: hidden; }
.ps-chan--open { border-color: var(--poyt-done-line); }
.ps-chan-h { margin: 0; font: inherit; }
.ps-chan-head {
  display: flex; align-items: center; gap: 14px; width: 100%; min-height: 54px; padding: 14px 18px; border: none; background: none;
  font: inherit; text-align: left; color: var(--poyt-ink); cursor: pointer;
}
.ps-chan-n { width: 26px; flex: none; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 18px; color: var(--poyt-orange); }
.ps-chan-t { flex: 1; font-weight: 600; font-size: 15.5px; }
.ps-chan-head .icon-line { stroke: var(--poyt-soft); fill: none; stroke-linecap: round; stroke-linejoin: round; flex: none; transition: transform 0.15s; }
.ps-chan-head .pp-chev--open { transform: rotate(180deg); }
.ps-chan-body { padding: 0 18px 16px 58px; font-size: 15px; }
.ps-chan-body p { margin: 0 0 10px; }
.ps-chan-meta { display: flex; gap: 6px 18px; flex-wrap: wrap; font-size: 13.5px; color: var(--poyt-soft); }
.ps-chan-meta b { font-weight: 600; color: var(--poyt-ink); }
.ps .ps-chan-note { margin-top: 10px; font-size: 14px; color: var(--poyt-soft); }

/* the campaign rule */
.ps-locked-chan { margin-bottom: 6px; padding: 12px 16px; border-radius: 10px; background: var(--poyt-navy); color: var(--on-dark); font-size: 15px; font-weight: 600; }
.ps-locked-chan span { display: block; font-weight: 400; font-size: 13.5px; color: var(--poyt-soft-on-navy); }
.ps-pick { display: flex; flex-direction: column; gap: 10px; margin-top: 16px; }
.ps-pick .ps-opt { width: 100%; }

/* ticks */
.ps-checks { margin: 26px 0 0; padding: 0; border: none; min-width: 0; }
.ps-ex .ps-checks { margin-top: 0; }
.ps-checks legend { padding: 0; margin-bottom: 10px; }
.ps-check {
  display: flex; align-items: flex-start; gap: 12px; margin-bottom: 10px; padding: 14px 16px; border: 1px solid var(--poyt-rule);
  border-radius: 10px; background: var(--shell-bg); cursor: pointer;
}
.ps-check input { width: 20px; height: 20px; margin: 2px 0 0; flex: none; accent-color: var(--poyt-orange); color: var(--poyt-orange); }
.ps-check-text { font-size: 15px; line-height: 1.5; }
.ps-check--on { border-color: var(--poyt-orange); background: var(--poyt-navy-07); }
.ps .ps-check-sub { display: block; margin: 2px 0 0; font-size: 13.5px; }
.ps-gate-open { margin-top: 16px; }
.ps-gate-note { margin-top: 20px; }
.ps-gate-fin { margin: 30px 0 4px; text-align: center; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 32px; line-height: 1.2; }
.ps-stroke { position: relative; display: inline-block; }
.ps-stroke::after {
  content: ''; position: absolute; left: -2px; right: -6px; bottom: -7px; height: 5px; background: var(--poyt-orange-2); transform: skewX(-12deg);
}

/* ---- The diagrams */
.ps-vis { margin: 26px 0 8px; padding: 20px 20px 16px; border: 1px solid var(--poyt-rule); border-radius: 14px; background: var(--shell-bg); }
.ps-vis--bare { padding: 0; border: none; background: none; }
.ps-vis-head { font-family: var(--poyt-heading-font); font-weight: 700; font-size: 16px; color: var(--poyt-navy); }
.ps-vis-sub { margin: 3px 0 16px; font-size: 14px; line-height: 1.5; color: var(--poyt-soft); }
.ps-vis--bare .ps-vis-sub { margin-bottom: 0; }
.ps-vis-foot { margin-top: 14px; font-size: 14px; line-height: 1.55; color: var(--poyt-soft); }
.ps .ps-vis-foot strong { color: var(--poyt-ink); }
.ps-svg { display: block; width: 100%; height: auto; }
.ps-svg { font-family: var(--poyt-body-font); }
.ps-wf-line { stroke: var(--poyt-orange); stroke-width: 1.5; stroke-dasharray: 5 5; }
.ps-wf-tag { fill: var(--poyt-orange); font-family: var(--poyt-heading-font); font-weight: 700; font-size: 10.5px; letter-spacing: 0.08em; }
.ps-wf-link { stroke: var(--poyt-line); stroke-width: 1; stroke-dasharray: 3 3; }
.ps-wf-axis { stroke: var(--poyt-rule); stroke-width: 1; }
.ps-wf-value { fill: var(--poyt-navy-2); }
.ps-wf-gap { fill: var(--poyt-rule); }
.ps-wf-cut { fill: var(--poyt-line); }
.ps-wf-offer { fill: var(--poyt-orange); }
.ps-wf-name { fill: var(--poyt-soft); font-size: 11px; }
.ps-wf-name--across { font-size: 12.5px; }
.ps-wf-amt { fill: var(--poyt-ink); font-family: var(--poyt-heading-font); font-weight: 800; font-size: 15px; }
.ps-wf-amt--offer { fill: var(--poyt-orange); }
.ps-figs {
  margin: 16px 0 0; padding: 18px 24px; border-radius: 10px; background: var(--poyt-navy);
  display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 18px 24px; align-items: start;
}
.ps-figs-item { min-width: 0; }
.ps-figs dt { font-family: var(--poyt-heading-font); font-weight: 700; font-size: 11px; line-height: 1.35; letter-spacing: 0.11em; text-transform: uppercase; color: var(--poyt-soft-on-navy); }
.ps-figs dd { margin: 6px 0 0; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 20px; letter-spacing: -0.01em; color: var(--on-dark); font-variant-numeric: tabular-nums; }
@media (min-width: 901px) { .ps-figs-item + .ps-figs-item { border-left: 1px solid var(--on-dark-14); padding-left: 24px; } }

/* tables: the comparables and the 7 channels */
.ps-tbl { width: 100%; border-collapse: collapse; font-size: 14px; }
.ps-tbl th {
  padding: 0 12px 8px 0; border-bottom: 1px solid var(--poyt-rule); text-align: left; white-space: nowrap;
  font-family: var(--poyt-heading-font); font-weight: 700; font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; color: var(--poyt-soft);
}
.ps-tbl td { padding: 10px 12px 10px 0; border-bottom: 1px solid var(--poyt-rule); vertical-align: top; line-height: 1.45; }
.ps-tbl tr:last-child td { border-bottom: none; }
.ps .ps-tbl-out td { color: var(--poyt-soft); }
.ps-tbl-num { font-weight: 600; white-space: nowrap; font-variant-numeric: tabular-nums; }
.ps-tbl-lead { font-weight: 600; }
.ps-tag { display: inline-block; padding: 3px 7px; border-radius: 5px; font-size: 11px; font-weight: 700; letter-spacing: 0.07em; text-transform: uppercase; white-space: nowrap; }
.ps-tag--ceil { background: var(--poyt-navy); color: var(--on-dark); }
.ps-tag--floor { border: 1px solid var(--poyt-orange); color: var(--poyt-orange); }
.ps-tag--out { background: var(--poyt-rule-soft); color: var(--poyt-soft); }

/* rent */
.ps-rent { list-style: none; margin: 0; padding: 0; }
.ps-rent-row { display: flex; align-items: center; gap: 14px; padding: 11px 0; border-bottom: 1px solid var(--poyt-rule); }
.ps-rent-row:last-child { border-bottom: none; }
.ps-rent-amt { width: 86px; flex: none; display: flex; flex-direction: column; }
.ps-rent-amt b { font-family: var(--poyt-heading-font); font-weight: 800; font-size: 17px; color: var(--poyt-ink); }
.ps-rent-row--asking .ps-rent-amt b { color: var(--poyt-soft); }
.ps-rent-amt span { font-size: 12px; color: var(--poyt-soft); }
.ps-rent-bar-wrap { flex: 1; min-width: 0; }
.ps-rent-track { display: block; height: 9px; border-radius: 5px; background: var(--poyt-rule-soft); overflow: hidden; }
.ps-rent-bar { display: block; height: 100%; border-radius: 5px; background: var(--poyt-navy); }
.ps-rent-row--asking .ps-rent-bar { background: var(--poyt-orange); }
.ps-rent-note { display: block; margin-top: 5px; font-size: 13px; color: var(--poyt-soft); }

/* the 2 offers */
.ps-split { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin: 18px 0 8px; }
.ps-offer { padding: 22px 22px 20px; border: 1px solid var(--poyt-rule); border-radius: 14px; background: var(--shell-bg); }
.ps-offer--built { border-color: var(--poyt-orange); }
.ps-offer--locked { background: var(--poyt-paper); border-style: dashed; border-color: var(--poyt-line); }
.ps-offer-n { font-family: var(--poyt-heading-font); font-weight: 700; font-size: 11px; letter-spacing: 0.13em; text-transform: uppercase; color: var(--poyt-orange); }
.ps-offer--locked .ps-offer-n { color: var(--poyt-soft); }
.ps-offer-h { margin: 6px 0 12px; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 19px; letter-spacing: -0.01em; color: var(--poyt-navy); }
.ps-offer ul { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
.ps-offer li { position: relative; padding-left: 22px; font-size: 14px; line-height: 1.5; color: var(--poyt-soft); }
.ps-offer li::before { content: ''; position: absolute; left: 2px; top: 6px; width: 10px; height: 6px; border-left: 2px solid var(--poyt-orange); border-bottom: 2px solid var(--poyt-orange); transform: rotate(-45deg); }
.ps-offer--locked li::before { width: 8px; height: 8px; top: 6px; border: 1.5px solid var(--poyt-line); border-radius: 50%; transform: none; }
.ps-offer-blur { filter: blur(5px); opacity: 0.55; user-select: none; pointer-events: none; }
.ps-offer-stamp { margin-top: 18px; padding-top: 13px; border-top: 1px dashed var(--poyt-line); font-family: var(--poyt-heading-font); font-weight: 700; font-size: 13px; color: var(--poyt-soft); }
.ps-offer--built .ps-offer-stamp { color: var(--poyt-orange); border-top-color: var(--poyt-rule); }

/* the funnel */
.ps-funnel { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; align-items: center; gap: 10px; }
.ps-funnel-step { padding: 10px 16px; border-radius: 9px; text-align: center; display: flex; flex-direction: column; gap: 2px; min-width: 0; color: var(--on-dark); }
.ps-funnel-step b { font-family: var(--poyt-heading-font); font-weight: 700; font-size: 14px; line-height: 1.3; }
.ps-funnel-step span { font-size: 12.5px; line-height: 1.4; }
.ps-funnel-step--mid { background: var(--poyt-navy-2); }
.ps-funnel-step--mid span { color: var(--poyt-soft-on-navy); }
.ps-funnel-step--deep { background: var(--poyt-navy); }
.ps-funnel-step--deep span { color: var(--poyt-soft-on-navy); }
.ps-funnel-step--last { background: var(--poyt-orange); }
.ps-funnel-step--last span { color: var(--on-dark-86); }

/* near it, not on it */
.ps-node { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 20px; align-items: center; }
.ps-node-svg { max-width: 360px; margin: 0 auto; }
.ps-node-far { fill: var(--poyt-rule-soft); }
.ps-node-sweet { fill: var(--poyt-navy); fill-opacity: 0.14; }
.ps-node-on { fill: var(--poyt-orange); fill-opacity: 0.2; }
.ps-node-centre { fill: var(--poyt-navy); }
.ps-node-centre-text { fill: var(--on-dark); font-family: var(--poyt-heading-font); font-weight: 700; font-size: 10px; }
.ps-node-sweet-text { fill: var(--poyt-navy); font-family: var(--poyt-heading-font); font-weight: 700; font-size: 12px; }
.ps-node-key { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 16px; }
.ps-node-key-item { display: flex; gap: 12px; align-items: flex-start; }
.ps-node-dot { width: 12px; height: 12px; border-radius: 6px; flex: none; margin-top: 5px; }
.ps-node-key-item--on .ps-node-dot { background: var(--poyt-orange); }
.ps-node-key-item--sweet .ps-node-dot { background: var(--poyt-navy); }
.ps-node-key-item--far .ps-node-dot { background: var(--poyt-soft); }
.ps-node-key-text { display: flex; flex-direction: column; font-size: 13.5px; line-height: 1.45; color: var(--poyt-soft); }
.ps-node-key-text b { font-family: var(--poyt-heading-font); font-weight: 700; font-size: 14.5px; color: var(--poyt-ink); }

/* keep, amber, avoid */
.ps-crit { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; margin: 18px 0 8px; }
.ps-crit-col { padding: 18px; border: 1px solid var(--poyt-rule); border-radius: 12px; background: var(--shell-bg); }
.ps-crit-h { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; font-family: var(--poyt-heading-font); font-weight: 800; font-size: 15px; }
.ps-crit-dot { width: 10px; height: 10px; border-radius: 5px; display: block; }
.ps-crit-col--keep .ps-crit-dot { background: var(--poyt-navy); }
.ps-crit-col--amber .ps-crit-dot { background: var(--shell-bg); border: 2px solid var(--poyt-orange-2); }
.ps-crit-col--avoid .ps-crit-dot { background: var(--poyt-orange); }
.ps-crit-col--keep { border-color: var(--poyt-done-line); }
.ps-crit ul { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.ps-crit li { font-size: 13.5px; line-height: 1.5; color: var(--poyt-soft); }

/* ---- Between a laptop and a phone: the list of screens folds above the screen */
@media (max-width: 1099px) {
  .ps { grid-template-columns: minmax(0, 1fr); gap: 16px; max-width: 840px; }
  .ps-rail { padding: 16px 18px; }
  .ps-rail-head {
    padding: 0; border-bottom: none; display: grid; grid-template-columns: minmax(0, 1fr) auto; column-gap: 16px; row-gap: 4px; align-items: center;
  }
  .ps-rail-title { grid-column: 1; font-size: 17px; }
  .ps-rail-count { grid-column: 1; }
  .ps-rail-bar { grid-column: 1 / -1; }
  .ps-rail-toggle { display: inline-flex; grid-column: 2; grid-row: 1 / span 2; }
  .ps-rail-list { display: none; margin-top: 8px; }
  .ps-rail--open .ps-rail-list { display: block; }
}

/* ---- A phone (PhoneWeek.dc.html: 16px gutters, the page full width) */
@media (max-width: 760px) {
  .ps-rail { border-radius: 14px; padding: 14px 16px; }
  .ps-card { padding: 22px 18px 24px; border-radius: 14px; font-size: 16px; }
  .ps-eyebrow { font-size: 12px; letter-spacing: 0.14em; }
  .ps-h1 { font-size: 28px; margin: 8px 0 18px; }
  .ps-takeaway { flex-direction: column; gap: 4px; padding: 12px 14px; }
  .ps-takeaway b { width: auto; padding-top: 0; }
  .ps-script { padding: 14px 16px; }
  .ps-script p { font-size: 16px; }
  .ps-formula { padding: 18px; }
  .ps-formula-line { font-size: 17px; }
  .ps-ex-card { padding: 16px; }
  .ps-opts:not(.ps-opts--stack) .ps-opt { flex: 1 1 auto; text-align: center; }
  .ps-foot { flex-direction: column-reverse; align-items: stretch; }
  .ps-foot-left, .ps-foot-right { display: flex; flex-direction: column; align-items: stretch; gap: 10px; margin-left: 0; }
  .ps-foot-left:empty { display: none; }
  .ps-foot .ps-btn { width: 100%; }
  .ps-gate-help { max-width: none; text-align: left; }
  .ps-done-tag { justify-content: center; }
  .ps-calc { padding: 18px 16px; }
  .ps-calc-label { flex-basis: 100%; }
  .ps-calc input, .ps-calc select, .ps-calc .ps-toggle { width: 100%; }
  .ps-toggle button { flex: 1 1 0; }
  .ps-calc-out-num { font-size: 28px; }
  .ps-drill-in input { flex: 1 1 140px; width: auto; min-width: 0; }
  .ps-drill-in { flex-wrap: nowrap; }
  .ps-save-row .ps-btn { width: 100%; }
  .ps-chan-head { padding: 12px 14px; gap: 10px; }
  .ps-chan-body { padding: 0 14px 14px; }
  .ps-vis:not(.ps-vis--bare) { padding: 16px 14px 14px; }
  .ps-figs { grid-template-columns: minmax(0, 1fr); gap: 14px; padding: 16px 18px; }
  .ps-figs dd { font-size: 18px; }
  .ps-split, .ps-crit, .ps-node { grid-template-columns: minmax(0, 1fr); }
  .ps-node-svg { max-width: 280px; }
  .ps-gate-fin { font-size: 26px; }
  /* a table on a phone: each row a card, each cell with its column's name */
  .ps-tbl--stack thead { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); }
  .ps-tbl--stack, .ps-tbl--stack tbody, .ps-tbl--stack tr, .ps-tbl--stack td { display: block; width: 100%; }
  .ps-tbl--stack tr { padding: 10px 0; border-bottom: 1px solid var(--poyt-rule); }
  .ps-tbl--stack tr:last-child { border-bottom: none; }
  .ps-tbl--stack td { display: flex; justify-content: space-between; gap: 12px; padding: 3px 0; border-bottom: none; text-align: right; }
  .ps-tbl--stack td::before { content: attr(data-label); flex: none; max-width: 45%; text-align: left; font-size: 12px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: var(--poyt-soft); }
  .ps-tbl--stack td.ps-tbl-lead { display: block; text-align: left; font-size: 15px; padding-bottom: 4px; }
  .ps-tbl--stack td.ps-tbl-lead::before { display: none; }
  .ps-tbl--stack td.ps-tbl-tagcell { display: block; text-align: left; padding-top: 6px; }
  .ps-tbl--stack td.ps-tbl-tagcell:empty { display: none; }
  .ps-tbl--stack td.ps-tbl-tagcell::before { display: none; }
}
